import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

// import common from '../slices/common';
// import insurance from '../slices/insurance';
import encryption from './slices/encryption';
import user from '../store/slices/user';
import common from '../store/slices/common';
// Combine all reducers
const rootReducer = combineReducers({
  
//   common,
//   insurance,
encryption,
user,
common  
});

// Optional: logger middleware (only in development)
const logger = createLogger({
  collapsed: true,
  duration: true,
  diff: true,
});

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === 'development'
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware().concat(),
  devTools: process.env.NODE_ENV === 'development',
});

// Typed hooks support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
